<template>
  <div class="foot">
    <div class="bodyCenter">
      <div class="left">
        <div class="leftItem">
          <!-- <p>参展/参展联系</p> -->
          <p>{{ $t('footer.title') }}</p>
          <div class="box">
            <!-- 循环小图标以及icon -->
            <div class="item" v-for="(item, index) in exhibition" :key="index">
              <img :src="item.iconImg" alt="" class="img" />
              <span>{{ item.text }}</span>
            </div>
            <!-- 循环小图标以及icon -->
          </div>
        </div>

        <div class="rightItem">
          <p>{{ $t('footer.link') }}</p>
          <div class="box">
            <!-- 循环小图标以及icon -->
            <div class="item" v-for="(item, index) in link" :key="index">
              <span
                ><a :href="item.url" :target="item.target">{{ item.text }}</a></span
              >
            </div>
            <!-- 循环小图标以及icon -->
          </div>
        </div>
        <div class="bottom">
          <div v-for="(item, index) in unit" :key="index" class="unit">
            <span class="danWei">{{ item.title }}</span>
            <span class="val">{{ item.text }}</span>
          </div>
          <div class="last">{{ $t('footer.company') }}</div>
        </div>
      </div>
      <div class="right">
        <div class="box">
          <div class="img"><img src="../static/erweiMa.png" alt="" /></div>
          <p>{{ $t('footer.weChatOfficialAccount') }}</p>
          <p>{{ $t('footer.qrCodeAttention') }}</p>
        </div>
      </div>
    </div>

    <div class="fixedFoot">
      <div class="center">
        <span>{{ $t('footer.copyright') }}</span>
        <span>{{ $t('footer.technicalSupport') }}</span>
        <span>{{ $t('footer.spareNumber1') }}</span>
        <span>{{ $t('footer.spareNumber2') }}</span>
        <span>Copyright © 2018. All Rights Reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import { viewcz, viewcg, zwt, zhrc, hzZhanhui } from '../../utils/common.js';
export default {
  name: 'footBottom',
  data() {
    return {
      exhibition: [
        { iconImg: require('../static/address.png'), text: this.$t('footer.address') },
        { iconImg: require('../static/email.png'), text: 'chinaminexpo@vip.163.com' },
        { iconImg: require('../static/phone.png'), text: '0086 10 64253061' },
        { iconImg: require('../static/icon_web.png'), text: 'www.chinaminexpo.com' },
      ],
      // link: [{ text: ' 展会官网' }, { text: ' 参展申请' }, { text: ' 参观预登记' }, { text: ' 参观指南' }],
      link: [
        { text: this.$t('footer.linkUrl.viewcz'), url: viewcz() },
        { text: this.$t('footer.linkUrl.viewcg'), url: viewcg() },
        { text: this.$t('footer.linkUrl.zwt'), url: zwt() },
        { text: this.$t('footer.linkUrl.zhrc'), url: zhrc() },
        { text: this.$t('footer.linkUrl.hzZhanhui'), url: hzZhanhui() },
        { text: this.$t('footer.linkUrl.mjlt'), url: 'http://forum.chinaminexpo.com/', target: '_blank' },
      ],
      unit: [
        { title: this.$t('footer.unit.title1'), text: this.$t('footer.unit.text1') },
        { title: this.$t('footer.unit.title2'), text: this.$t('footer.unit.text2') },
        { title: this.$t('footer.unit.title3'), text: this.$t('footer.unit.text3') },
      ],
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.foot {
  width: 100vw;
  height: 320px;
  background-image: url('../static/backImg.png');
  background-position: center;
  height: 100%;
  width: 100%;
  padding-bottom: 50px;
  background-size: cover;
  position: relative;
  overflow: hidden;
  .bodyCenter {
    width: 1270px;
    height: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    padding-top: 51px;
    justify-content: space-between;
    .left {
      display: flex;
      position: relative;
      .leftItem {
        width: 776px;
        p {
          margin-bottom: 30px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
        .box {
          display: flex;
          flex-wrap: wrap;
          // border: 1px solid red;
          justify-content: flex-start;
          .item {
            padding-bottom: 10px;
            box-sizing: border-box;
            width: fit-content;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-right: 42px;
            width: 345px;
            .img {
              width: 20px;
              height: 20px;
              margin-right: 15px;
            }
            span {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              line-height: 26px;
            }
          }
        }
      }
      .rightItem {
        height: 200px;
        width: fit-content;
        p {
          margin-bottom: 30px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
        .box {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          justify-content: flex-start;
          width: 328px;
          // box-sizing: border-box;
          // border: 1px solid red;
          

          .item {
            min-width: 89px;

            color: #ffffff;
            box-sizing: border-box;
            margin-bottom: 10px;
            margin-right: 20px;
            a {
              text-decoration: none;
              color: #ffffff;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
            }
          }
        }
      }
      .bottom {
        position: absolute;
        bottom: 18px;
        width: 1130px;
        .unit {
          float: left;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          padding-right: 39px;
          box-sizing: border-box;
          .danWei {
            color: #fdd000;
            margin-right: 8px;
          }
          .val {
            color: #ffff;
          }
        }
        .last {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          position: relative;
          left: -25px;
          box-sizing: border-box;
          color: #ffff;
        }
      }
    }
    .right {
      width: 100%;
      height: 100%;
      margin-left:2px;
      .box {
        width: fit-content;

        text-align: center;
        .img {
          width: 121px;
          height: 121px;
          margin-bottom: 15px;
          margin: 0 auto;
        }
        p {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }
  }

  .fixedFoot {
    min-width: 1270px !important;
    position: absolute;
    left: 0px;
    right: 0px;
    margin: auto;
    bottom: 0px;
    width: 100vw;
    height: 50px;
    background: #000000;
    opacity: 0.6;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a4cdff;
    .center {
      margin: 0 auto;
      width: 1270px;
      display: flex;
      justify-content: space-between;
    }
  }
}
// .unit :last-child
</style>
